import { Routes, Route, useLocation, Navigate, useParams } from "react-router-dom"
import { About, Edit, Favourites, History, Notifications, Promocode, Support } from "./pages/profile/screens"
import { Afisha, Contacts, Forbidden, NotFound, Promo, ServerError, Tickets } from "./pages"
import Film from "./pages/Film"
import Buy from "./pages/buy/Buy"
import Location from "./pages/location/Location"
import Auth from "./pages/auth/Auth"
import Profile from "./pages/profile/Profile"
import RequireLocation from "../components/RequireLocation"
import CinemaPlaceLayout, { MaybeRedirectToCinema } from "../components/CinemaPlaceLayout"
import Privacy from "./pages/Privacy"
import Terms from "./pages/Terms"
import PersonalData from "./pages/PersonalData"
import PurchaseTerms from "./pages/PurchaseTerms"
import StartGate from "../components/StartGate"
import { hrefForCurrentCinema } from "../lib/cinemaSlugs"

function RedirectToCurrentAfisha({ search = "" }: { search?: string }) {
    return <Navigate to={`${hrefForCurrentCinema("/afisha")}${search}`} replace />
}

function LegacyFilmRedirect() {
    const { filmId } = useParams()
    return (
        <MaybeRedirectToCinema suffix={`/afisha/film/${filmId}`}>
            <Film />
        </MaybeRedirectToCinema>
    )
}

function LegacyPromoRedirect() {
    const { promoSlug } = useParams()
    return (
        <MaybeRedirectToCinema suffix={`/promo/${promoSlug}`}>
            <Promo />
        </MaybeRedirectToCinema>
    )
}

const Main = ({ location }: { location: any }) => {
    const { pathname } = useLocation()
    const isStart = pathname === "/"
    const isFullWidth = isStart || pathname === "/tickets"

    return (
        <main
            className={`w-full grow ${
                isFullWidth ? "" : "mx-auto max-w-3xl pb-28 lg:max-w-5xl xl:max-w-7xl"
            }`}
            style={{
                /* Высота шапки совпадает с --header-height на текущем брейкпоинте. */
                paddingTop: "calc(var(--header-height) + env(safe-area-inset-top))",
                ...(!isFullWidth
                    ? { paddingBottom: "calc(7rem + var(--safe-bottom))" }
                    : {}),
            }}>
            <Routes location={location}>
                <Route path="/" element={<StartGate />} />
                <Route
                    path="/afisha"
                    element={
                        <MaybeRedirectToCinema suffix="/afisha">
                            <Afisha />
                        </MaybeRedirectToCinema>
                    }
                />
                <Route path="/afisha/film/:filmId" element={<LegacyFilmRedirect />} />
                <Route path="/home" element={<RedirectToCurrentAfisha />} />

                <Route path="/auth" element={<Auth />} />
                <Route path="/location" element={<Location />} />
                <Route path="/buy" element={<RequireLocation><Buy /></RequireLocation>} />

                <Route path="/tickets" element={<RequireLocation><Tickets /></RequireLocation>} />
                <Route
                    path="/contacts"
                    element={
                        <MaybeRedirectToCinema suffix="/contacts">
                            <Contacts />
                        </MaybeRedirectToCinema>
                    }
                />
                <Route path="/news" element={<RedirectToCurrentAfisha />} />
                <Route path="/promo" element={<RedirectToCurrentAfisha search="?tab=aktsii" />} />
                <Route path="/promo/:promoSlug" element={<LegacyPromoRedirect />} />
                <Route path="/more" element={<Navigate to="/profile/about" replace />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/personal-data" element={<PersonalData />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/purchase-terms" element={<PurchaseTerms />} />
                <Route path="/profile" element={<RequireLocation><Profile /></RequireLocation>}>
                    <Route path="edit" element={<Edit />} />
                    <Route path="about" element={<About />} />
                    <Route path="notifications" element={<Notifications />} />
                    <Route path="favourites" element={<Favourites />} />
                    <Route path="history" element={<History />} />
                    <Route path="promocode" element={<Promocode />} />
                    <Route path="support" element={<Support />} />
                </Route>
                <Route path="/403" element={<Forbidden />} />
                <Route path="/500" element={<ServerError />} />

                <Route path="/:place" element={<CinemaPlaceLayout />}>
                    <Route index element={<Navigate to="afisha" replace />} />
                    <Route path="afisha" element={<Afisha />} />
                    <Route path="afisha/film/:filmId" element={<Film />} />
                    <Route path="promo/:promoSlug" element={<Promo />} />
                    <Route path="contacts" element={<Contacts />} />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Routes>
        </main>
    )
}

export default Main
